/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {
  Table,
  Button,
  Icon,
  Text,
} from 'components/atoms';
import { Tooltip } from 'components/molecules'
import { injectIntl } from 'react-intl'
import { intlType } from 'types'

const PeopleTable = memo(({
  data,
  loading,
  intl,
  noDataText,
  onRemove,
  showPermissionsColumn
}) => (
  <Table
    data={data}
    columns={[
      {
        Header: intl.formatMessage({ id: 'name' }),
        accessor: 'name',
        Cell: ({ value }) => (
          <Table.Cell
            value={value}
            loadingDots={loading}
          />
        ),
      },
      ...(showPermissionsColumn
        ? [{
          Header: 'permissões para',
          accessor: 'permissions',
          Cell: ({ value }) => (
            <Table.Cell
              value={value}
              loading={loading}
            />
          ),
        }]
        : []
      ),
      {
        Header: intl.formatMessage({ id: 'email' }),
        accessor: 'email',
        Cell: ({ value }) => (
          <Table.CellLink
            as="a"
            href={`mailto:${value}`}
            target="_blank"
            rel="noopener noreferrer"
            modifiers={['clearPadding']}
          >
            <Table.Cell loading={loading}>
              <Text
                modifiers={['light', 'underline']}
              >
                {value}
              </Text>
            </Table.Cell>
          </Table.CellLink>
        ),
      },
      {
        Header: '',
        accessor: 'actions',
        resizable: false,
        width: 80,
        Cell: ({ original }) => (
          <Tooltip tooltip="Remover permissões" placement="top">
            <CellEnd>
              <Button modifiers={['small', 'invisibleWithHover']} onClick={() => onRemove(original)}>
                <Icon icon="fal fa-times" height={16} />
              </Button>
            </CellEnd>
          </Tooltip>
        ),
      }
    ]}
    minRows={0}
    className="-striped -highlight"
    noDataText={loading ? '' : (noDataText || 'Não foram encontradas pessoas')}
    sortable={false}
    showPagination={false}
    loading={loading}
    loadingText="A carregar..."
  />
));

const CellEnd = styled.div`
  width: 100%;
  text-decoration: none;
`

PeopleTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  loading: PropTypes.bool,
  intl: intlType.isRequired,
  noDataText: PropTypes.string,
  onRemove: PropTypes.func,
  showPermissionsColumn: PropTypes.bool,
};

PeopleTable.defaultProps = {
  data: [],
  loading: true,
  noDataText: null,
  onRemove: () => null,
  showPermissionsColumn: true,
}


export default injectIntl(PeopleTable);
